import { render, staticRenderFns } from "./BtnCreateDataExport.vue?vue&type=template&id=42a17f24"
import script from "./BtnCreateDataExport.vue?vue&type=script&lang=js"
export * from "./BtnCreateDataExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports